import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { ClientPortalConfigStore } from '~/components/ClientExperience/stores/client-portal-config.store';
import { S3ApiAdapter } from '~/components/ClientExperience/services/adapters/s3-api.adapter';

export class CompanyCXAdapter extends BaseHttpAdapter {
    clientPortalConfigStore: ClientPortalConfigStore;

    constructor({
        clientPortalConfigStore,
        s3ApiAdapter
    }: {
        clientPortalConfigStore: ClientPortalConfigStore;
        s3ApiAdapter: S3ApiAdapter;
    }) {
        super(s3ApiAdapter);

        this.clientPortalConfigStore = clientPortalConfigStore;
    }

    async _fetchCompanyBrandingData<ICompanyBrandingData>(placementId: string) {
        const { s3PlacementFilesUrlPrefix } = this.clientPortalConfigStore;

        return this.apiService.apiRequest<ICompanyBrandingData>({
            url: `${s3PlacementFilesUrlPrefix}/websiteplacements/${placementId}/company_branding.js?xhr=1`,
            isJsonp: true
        });
    }
}
